<mat-tab-group class="employee-account-tabs" mat-align-tabs="start" mat-stretch-tabs="false">
  @if (isAgreementSigningTabActive$ | async) {
    <mat-tab [label]="'account.documents-signing' | translate">
      <app-agreement-sign-page></app-agreement-sign-page>
    </mat-tab>
  }
  <mat-tab
    *flexyooLet="userLanguage$ | async as userLanguage"
    [label]="'account.documents-review' | translate"
  >
    <div class="docs">
      <div class="cards-wrapper">
        <mat-card appearance="outlined">
          <mat-card-title>
            <div class="card-title">
              {{ 'account.documents.general-documents' | translate }}
            </div>
          </mat-card-title>
          <mat-card-content class="empl-documents-block">
            <div class="empl-documents-block__row">
              <span class="empl-documents-block__row-label">
                {{ 'base-layout.privacy-statement' | translate }}
              </span>
              <button
                class="empl-documents-icon-button"
                matIconButton
                type="button"
                (click)="onPrivacyStatement(userLanguage)"
              >
                <mat-icon svgIcon="fo-tray-download"></mat-icon>
              </button>
            </div>
            <div class="empl-documents-block__row">
              <span class="empl-documents-block__row-label">
                {{ 'base-layout.employee-user-guide' | translate }}
              </span>
              <button
                class="empl-documents-icon-button"
                matIconButton
                type="button"
                (click)="fileEmployeeUserGuide.click()"
              >
                <mat-icon svgIcon="fo-tray-download"></mat-icon>
              </button>
              <a
                #fileEmployeeUserGuide
                download
                style="display: none"
                target="_blank"
                [href]="staticEmployeeUserGuide$ | async"
              ></a>
            </div>
          </mat-card-content>
        </mat-card>

        @if (isCafeteriaPlanEnrolled$ | async) {
          <mat-card appearance="outlined">
            <mat-card-title>
              <div class="card-title">
                {{ 'account.my-documents' | translate }} -
                {{ 'financing-plans.cafeteria-plan' | translate }}
              </div>
            </mat-card-title>
            <mat-card-content class="empl-documents-block">
              <div class="empl-documents-block__row">
                <span class="empl-documents-block__row-label">
                  {{ 'account.documents.general-plan-policy' | translate }}
                </span>
                <button
                  class="empl-documents-icon-button"
                  matIconButton
                  type="button"
                  (click)="onGeneralPolicyDownload(userLanguage, ApplicationPlanType.Cafeteria)"
                >
                  <mat-icon svgIcon="fo-tray-download"></mat-icon>
                </button>
              </div>
              @for (agreement of cafeteriaAgreements$ | async; track agreement.id) {
                <div class="empl-documents-block__row">
                  <span class="empl-documents-block__row-label">
                    {{ agreement.year }} {{ 'account.documents.user-agreement' | translate }}
                  </span>
                  <button
                    class="empl-documents-icon-button"
                    matIconButton
                    type="button"
                    (click)="downloadUserAgreement(agreement)"
                  >
                    <mat-icon svgIcon="fo-tray-download"></mat-icon>
                  </button>
                </div>
              }
            </mat-card-content>
          </mat-card>
        }

        <ng-container *flexyooLet="financialImpactReports$ | async as reports">
          @if (reports?.length) {
            <mat-card appearance="outlined">
              <mat-card-title>
                <div class="card-title">
                  <span class="card-title__text">
                    {{ 'financing-plans.cafeteria-plan' | translate }} -
                    {{ 'account.documents.financial-impact' | translate }}
                  </span>
                  <span class="card-title__badge">{{ reports.length }}</span>
                  <button
                    class="card-title__toggle"
                    matIconButton
                    type="button"
                    [attr.aria-expanded]="isFinancialImpactExpanded()"
                    [attr.aria-label]="
                      'general.' + (isFinancialImpactExpanded() ? 'collapse' : 'expand') | translate
                    "
                    (click)="toggleFinancialImpact()"
                  >
                    <mat-icon>{{
                      isFinancialImpactExpanded()
                        ? 'keyboard_double_arrow_up'
                        : 'keyboard_double_arrow_down'
                    }}</mat-icon>
                  </button>
                </div>
              </mat-card-title>
              @if (isFinancialImpactExpanded()) {
                <mat-card-content class="empl-documents-block">
                  @for (report of reports; track report.periodId) {
                    <div class="empl-documents-block__row">
                      <span class="empl-documents-block__row-label">
                        {{ report.year }} - <strong>{{ report.name }}</strong>
                        <span class="report-period">
                          ({{ report.startDate | date: 'dd/MM/yyyy' }} -
                          {{ report.endDate | date: 'dd/MM/yyyy' }})
                        </span>
                        - {{ 'account.documents.financial-impact-report' | translate }}
                      </span>
                      <button
                        class="empl-documents-icon-button"
                        matIconButton
                        type="button"
                        [disabled]="report.isDownloading"
                        (click)="downloadFinancialImpactReport(report)"
                      >
                        @if (report.isDownloading) {
                          <mat-spinner class="download-spinner" [diameter]="20"></mat-spinner>
                        } @else {
                          <mat-icon svgIcon="fo-tray-download"></mat-icon>
                        }
                      </button>
                    </div>
                  }
                </mat-card-content>
              }
            </mat-card>
          }
        </ng-container>
      </div>

      @if (isMobilityBudgetPlan$ | async) {
        <div class="cards-wrapper">
          <mat-card appearance="outlined">
            <mat-card-title>
              <div class="card-title">
                {{ 'account.my-documents' | translate }} -
                {{ 'financing-plans.mobility-budget' | translate }}
              </div>
            </mat-card-title>
            <mat-card-content class="empl-documents-block">
              <div class="empl-documents-block__row">
                <span class="empl-documents-block__row-label">
                  {{ 'account.documents.policy-for-mobility-budget' | translate }}
                </span>
                <button
                  class="empl-documents-icon-button"
                  matIconButton
                  type="button"
                  (click)="
                    onGeneralPolicyDownload(userLanguage, ApplicationPlanType.MobilityBudget)
                  "
                >
                  <mat-icon svgIcon="fo-tray-download"></mat-icon>
                </button>
              </div>
              @for (agreement of mobilityBudgetAgreements$ | async; track agreement.id) {
                <div class="empl-documents-block__row">
                  <span class="empl-documents-block__row-label">
                    {{ agreement.year }} {{ 'account.documents.lmb-user-agreement' | translate }}
                  </span>
                  <button
                    class="empl-documents-icon-button"
                    matIconButton
                    type="button"
                    (click)="downloadUserAgreement(agreement)"
                  >
                    <mat-icon svgIcon="fo-tray-download"></mat-icon>
                  </button>
                </div>
              }
            </mat-card-content>
          </mat-card>
        </div>
      }
    </div>
  </mat-tab>
</mat-tab-group>
